import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "offset-md-1 col-12 col-md-10" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "input-row col-12 col-md-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Anrede", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Firma", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Herr", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Frau", -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "input-row col-12 col-md-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "Firstname" }, "Vorname", -1)
const _hoisted_11 = { class: "input-row col-12 col-md-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "Lastname" }, "Nachname", -1)
const _hoisted_13 = { class: "input-row col-8 col-md-9" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "Street" }, "Straße", -1)
const _hoisted_15 = { class: "input-row col-4 col-md-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "Housenumber" }, "Hausnummer", -1)
const _hoisted_17 = {
  key: 0,
  class: "input-row col-12"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "PlzAndPlace" }, "PLZ und Ort", -1)
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 1,
  class: "input-row col-4 col-md-6"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "PLZ" }, "PLZ", -1)
const _hoisted_23 = {
  key: 2,
  class: "input-row col-8 col-md-6"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "Place" }, "Ort", -1)
const _hoisted_25 = { class: "input-row col-12 col-md-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "Email" }, "E-Mail", -1)
const _hoisted_27 = { class: "input-row col-12 col-md-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "Phone" }, "Telefonnummer", -1)
const _hoisted_29 = {
  key: 3,
  class: "input-row col-12 col-md-6"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "Phone" }, "Geburtsdatum (DD.MM.YYYY)", -1)

import { ILicenseOffice, IOrderData, IUserData } from '@/classes/interfaces/data';
import { PropType, ref, computed, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  LicenseOffice: { type: Object as PropType<ILicenseOffice>, required: true },
  UserData: { type: Object as PropType<IUserData>, required: true },
  OrderData: { type: Object as PropType<IOrderData>, required: true },
},
  emits: ["update:UserData"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:UserData', value: IUserData): void;
}), expose: any, slots: any, attrs: any }) {

const Props = __props




const CustomPlaceSelectValue = ref<string>('');

const UserDataInternal = ref<IUserData>({
  Title: '',
  Firstname: '',
  Lastname: '',
  Street: '',
  Housenumber: '',
  PLZ: '',
  Place: '',
  Email: '',
  Phone: '',
  Birthdate: '',
});

const OnCustomPlaceChange = (event: Event): void => {
  const value = (event.target as HTMLSelectElement).value;

  UserDataInternal.value.PLZ = value.substring(0, value.indexOf(' '));
  UserDataInternal.value.Place = value.substring(value.indexOf(' ') + 1);

  CustomPlaceSelectValue.value = value;

  Update();
};

const Update = () => {
  emit('update:UserData', UserDataInternal.value);
};

onMounted(() => {
  UserDataInternal.value = Props.UserData;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("select", {
          name: "title",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((UserDataInternal.value.Title) = $event)),
          onChange: Update
        }, _hoisted_8, 544), [
          [_vModelSelect, UserDataInternal.value.Title]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "Firstname",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((UserDataInternal.value.Firstname) = $event)),
          onChange: Update
        }, null, 544), [
          [_vModelText, UserDataInternal.value.Firstname]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "Lastname",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((UserDataInternal.value.Lastname) = $event)),
          onChange: Update
        }, null, 544), [
          [_vModelText, UserDataInternal.value.Lastname]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "Street",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((UserDataInternal.value.Street) = $event)),
          onChange: Update
        }, null, 544), [
          [_vModelText, UserDataInternal.value.Street]
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "Housenumber",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((UserDataInternal.value.Housenumber) = $event)),
          onChange: Update
        }, null, 544), [
          [_vModelText, UserDataInternal.value.Housenumber]
        ])
      ]),
      (__props.LicenseOffice?.input_restriction?.RestrictPLZAndPlace == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("select", {
              name: "PlzAndPlace",
              value: CustomPlaceSelectValue.value,
              onChange: OnCustomPlaceChange
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.LicenseOffice?.input_restriction?.PlzAndPlace, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item.PlzAndPlace,
                  key: item.PlzAndPlace
                }, _toDisplayString(item.PlzAndPlace), 9, _hoisted_20))
              }), 128))
            ], 40, _hoisted_19)
          ]))
        : _createCommentVNode("", true),
      (__props.LicenseOffice?.input_restriction?.RestrictPLZAndPlace != true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "PLZ",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((UserDataInternal.value.PLZ) = $event)),
              inputmode: "numeric",
              onChange: Update,
              maxlength: "5"
            }, null, 544), [
              [_vModelText, UserDataInternal.value.PLZ]
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.LicenseOffice?.input_restriction?.RestrictPLZAndPlace != true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _hoisted_24,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "Place",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((UserDataInternal.value.Place) = $event)),
              onChange: Update
            }, null, 544), [
              [_vModelText, UserDataInternal.value.Place]
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _withDirectives(_createElementVNode("input", {
          type: "email",
          name: "Email",
          inputmode: "email",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((UserDataInternal.value.Email) = $event)),
          onChange: Update
        }, null, 544), [
          [_vModelText, UserDataInternal.value.Email]
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "Phone",
          inputmode: "tel",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((UserDataInternal.value.Phone) = $event)),
          onChange: Update
        }, null, 544), [
          [_vModelText, UserDataInternal.value.Phone]
        ])
      ]),
      (__props.OrderData.executeReservation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _hoisted_30,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "Birthdate",
              inputmode: "numeric",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((UserDataInternal.value.Birthdate) = $event)),
              onChange: Update,
              maxlength: "10"
            }, null, 544), [
              [_vModelText, UserDataInternal.value.Birthdate]
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})